import * as React from 'react';

import { StyledFooterLink } from './StyledFooterLink';
interface IFooterLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  hideOnDesktop?: boolean;
  hideOnMobile?: boolean;
  asListItem?: boolean;
}

export const FooterLink: React.FC<IFooterLinkProps> = ({
  children,
  hideOnDesktop = false,
  hideOnMobile = false,
  asListItem = true,
  ...anchorProps
}) => {
  const ListItemWrap = asListItem ? 'li' : React.Fragment;

  return (
    <ListItemWrap>
      <StyledFooterLink
        hideOnMobile={hideOnMobile && hideOnMobile}
        hideOnDesktop={hideOnDesktop && hideOnDesktop}
        {...anchorProps}
      >
        {children}
      </StyledFooterLink>
    </ListItemWrap>
  );
};

export default FooterLink;
